import { ReactNode, createContext, useContext, useState } from 'react'

type PollingDisabledContextType = {
  isPollingDisabled: boolean
  disablePolling: () => void
  enablePolling: () => void
}

const PollingDisabledContext = createContext<PollingDisabledContextType | undefined>(
  undefined
)

export const PollingDisabledProvider = ({ children }: { children: ReactNode }) => {
  const [isPollingDisabled, setIsPollingDisabled] = useState(false)

  const disablePolling = () => setIsPollingDisabled(true)
  const enablePolling = () => setIsPollingDisabled(false)

  return (
    <PollingDisabledContext.Provider
      value={{ isPollingDisabled, disablePolling, enablePolling }}
    >
      {children}
    </PollingDisabledContext.Provider>
  )
}

export const usePollingDisabled = () => {
  const context = useContext(PollingDisabledContext)
  if (!context) {
    throw new Error(
      'usePollingDisabled must be used within a PollingDisabledProvider'
    )
  }
  return context
}
